import React from 'react';

export const BackSvg = () => (
    <svg className='m-auto my-4' width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.75 4.43301C0.416667 4.24056 0.416666 3.75944 0.75 3.56699L6.75 0.102885C7.08333 -0.0895656 7.5 0.150997 7.5 0.535897L7.5 7.4641C7.5 7.849 7.08333 8.08956 6.75 7.89711L0.75 4.43301Z" fill="white"/>
    </svg>
);

export function ForthSvg() {
    return (
        <svg className='mx-auto my-4' width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.25 4.43301C7.58333 4.24056 7.58333 3.75944 7.25 3.56699L1.25 0.102885C0.916667 -0.0895656 0.5 0.150997 0.5 0.535897L0.5 7.4641C0.5 7.849 0.916667 8.08956 1.25 7.89711L7.25 4.43301Z" fill="white" />
        </svg>
    );
}